import * as React from 'react';
import {
    TopToolbar,
    FilterButton,
    CreateButton,
    List, Datagrid, useListContext,
    TextField, NumberField, BooleanField,
    TextInput, NumberInput, SelectInput, NullableBooleanInput, SelectField, FunctionField
} from 'react-admin';
import PostForm from './Form';
import _style from './css/style.css';
import _exporter from '../../exporter';
import { formatLocalTime } from '../../../components/ex_dayjs';
import { RaPagination } from '../../../components/ra-list/RaList';
import RaExporter from '../../../components/ra-list/RaExporter';
import { dataProvider } from '../../../DataProvider';
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';

const objFilter = {
    PrimaryMarkets: [
        { id: 0, name: 'Ticketmaster' },
        { id: 2, name: '3TM' },
    ],
    ClientIds: [
        { id: 'VIVID_EL_A', name: 'VIVID_EL_A' },
        { id: 'VIVID_EL_B', name: 'VIVID_EL_B' },
        { id: 'VIVID_EL_C', name: 'VIVID_EL_C' },
        { id: 'VIVID_EL_D', name: 'VIVID_EL_D' },
        { id: 'EL2', name: 'EL2' },
        { id: 'SPEC 1', name: 'SPEC 1' },
        { id: 'POS3N', name: 'POS3N' },
        { id: 'POS3N_A', name: 'POS3N_A' },
        { id: 'POS3N_B', name: 'POS3N_B' },
        { id: 'POS4', name: 'POS4' },
        { id: 'LM', name: 'VIVID_LM' },
    ]
};

const FormView = () => <PostForm objFilter={objFilter}></PostForm>;

interface IData {
    [key: string]: any;
}

const ListActions: React.FC<IData> = ({ isAdmin }) => {
    const { filter, sort, resource } = useListContext();
    return (
        <TopToolbar>
            <FilterButton />
            {isAdmin && <CreateButton />}
            <RaExporter resource={resource}
                exportFile={{ columns: ['TmUsername', ...(isAdmin ? ['TmPassword'] : []), 'CvvCode', 'ClientId', 'Proxy', 'AllowAP', 'AllowTransfer', 'Updated', 'UpdatedBy'] }}
                params={{ filter, sort }} />
        </TopToolbar>
    );
};
const postFilters = [
    <TextInput source="tmUsername" alwaysOn />,
    <TextInput source="proxy" alwaysOn />,
    <SelectInput label="Client ID" source="clientId" choices={objFilter.ClientIds} translateChoice={false} alwaysOn />,
    <SelectInput label="Primary market" source="market" choices={objFilter.PrimaryMarkets} translateChoice={false} alwaysOn fullWidth />,
    <NullableBooleanInput label="Allow AP" source="allowAP" alwaysOn />,
    <NullableBooleanInput label="Allow AT" source="allowTransfer" alwaysOn />,
    <NullableBooleanInput source="allowPurchase" />,
    <NumberInput source="priority" />
];

const RAList = () => {
    const [isAdmin, setAdmin] = React.useState(null);

    React.useEffect(() => {
        dataProvider.fetchData('PrimaryAccount', 'IsAdmin').then((resonse: any) => {
            if (resonse.data !== null) setAdmin(resonse.data);
        }).catch((_: any) => _);
    }, []);

    return (
        <>
            {isAdmin !== null && <List title="Primary accounts"
                className='primary-accounts-page'
                storeKey={false}
                disableSyncWithLocation
                exporter={(records) => _exporter(records,
                    ['TmUserName', 'TmPassword', 'CvvCode', 'ClientId', 'Proxy', 'AllowAP', 'AllowTransfer', 'Updated', 'UpdatedBy'])}
                perPage={25}
                pagination={<RaPagination />}
                sort={{ field: 'Updated', order: 'DESC' }}
                filters={postFilters}
                actions={<ListActions isAdmin={isAdmin} />}>
                <Datagrid rowClick="edit" bulkActionButtons={false}>
                    <TextField source="id" />
                    <TextField source="tmUsername" />
                    <FunctionField source="tmPassword" render={_record => <IconButton disabled={!isAdmin} > {!isAdmin ? <VisibilityOffOutlined sx={{ fontSize: '18px' }} /> : <VisibilityOutlined sx={{ fontSize: '18px' }} />}</IconButton>} cellClassName='cell-center-reactadmin' />
                    <SelectField source="market" choices={objFilter.PrimaryMarkets} translateChoice={false} />,
                    <TextField source="cvvCode" label="CVV" />
                    {/* <TextField source="priority" />
                    <NumberField source="frequence" /> */}
                    <NumberField label="Client ID" source="clientId" />
                    <NumberField source="proxy" />
                    <BooleanField label="Allow AP" source="allowAP" cellClassName='cell-center-reactadmin' />
                    <BooleanField label="Allow AT" source="allowTransfer" cellClassName='cell-center-reactadmin' />
                    {/* <BooleanField source="allowPurchase" /> */}
                    <FunctionField source="updated" render={record => formatLocalTime(record.updated)} />
                    < TextField source="updatedBy" />
                    {/* <EditButton /> */}
                    {/* <DeleteButton /> */}
                </Datagrid>
            </List>
            }
        </>
    );
};
const RAPage = {
    name: 'PrimaryAccount',
    create: FormView,
    edit: FormView,
    list: RAList
};
export default RAPage;